import React from 'react';
import { Grid, Typography } from '@mui/material';

export interface ItemOption {
  name: string;
  unitCost: number;
}

export interface BasketItem {
  numberOfItems: number;
  name: string;
  unitCost: number;
  itemOptions?: ItemOption[];
}

interface OrderBasketItemProps {
  item: BasketItem;
}

const OrderBasketItem = ({ item }: OrderBasketItemProps) => {
  const hasItemOptions =
    item.hasOwnProperty('itemOptions') && item.itemOptions.length > 0;

  const getTotalPrice = () => {
    let itemPrice = item.unitCost * item.numberOfItems;
    let optionItemsPrice = 0;
    if (hasItemOptions) {
      item.itemOptions.forEach(item => {
        optionItemsPrice += item.unitCost;
      });
    }
    return (itemPrice + optionItemsPrice).toFixed(2);
  };

  return (
    <div style={{ marginBottom: '16px' }}>
      <Grid container alignItems="center">
        <Grid item xs={2}>
          <Typography variant="body1" style={{ fontWeight: 'bold', fontSize: '28px' }}>
            {item.numberOfItems}x
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <div>
            <Typography variant="body1">
              {item.name}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              €{item.unitCost.toFixed(2)} each
            </Typography>
          </div>
        </Grid>
        <Grid item xs={3} style={{ textAlign: 'right' }}>
          <Typography variant="body1" style={{ fontWeight: 'bold' }}>
            €{getTotalPrice()}
          </Typography>
        </Grid>
      </Grid>
      {hasItemOptions && item.itemOptions && (
        <div style={{ marginTop: '8px' }}>
          {item.itemOptions.map((opt, i) => (
            <Grid container key={`option-items-${i}`} style={{ marginBottom: '4px' }} alignItems="center">
              <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">
                  {opt.name}
                </Typography>
              </Grid>
              <Grid item xs={3} style={{ textAlign: 'right' }}>
                {opt.unitCost > 0 && (
                  <Typography variant="body2" color="textSecondary">
                    €{opt.unitCost.toFixed(2)}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={3}>
                {/* Empty grid item to maintain spacing */}
              </Grid>
            </Grid>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrderBasketItem;